<rg-loader></rg-loader>
@if (appInitialized) {
  <div
    id="app-content"
    tabindex="-1"
    role="main"
     [ngClass]="{
      'page': true
     }"
    >
    @if (showHeader | async) {
      <div class='page__header'>
        <app-header></app-header>
      </div>
    }
    <div class='page__content'>
      <router-outlet></router-outlet>
    </div>
    @if (showFooter | async) {
      <div class='page__footer'>
        <app-footer></app-footer>
      </div>
    }
    <app-notifications></app-notifications>
  </div>
}
